(() => {
  'use strict';
  function initialize(root = document) {
    root.querySelectorAll('[data-eb-country-select]').forEach(select => {
      if (select.dataset.initialized) return;
      select.dataset.initialized = 'true';
      select.addEventListener('change', () => select.form.requestSubmit());
    });
    const page = root.querySelector('[data-eb-page]');
    if (!page || page.dataset.initialized) return;
    page.dataset.initialized = 'true';
    const currency = page.dataset.ebCurrency || 'AUD';
    const baseCurrency = page.dataset.ebBaseCurrency || currency;
    const baseUnitPrice = Number(page.dataset.ebBaseUnitPrice);
    const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency}).format(cents / 100);
    const unitPrice = Number(page.dataset.ebUnitPrice);
    const entryPrice = page.querySelector('[data-eb-entry-price]');
    if (entryPrice) entryPrice.textContent = page.dataset.ebEntryPriceTemplate.replace('[price]', money(unitPrice));
    const suppliedRate = Number(window.Shopify?.currency?.rate);
    const fallbackRate = baseUnitPrice > 0 ? unitPrice / baseUnitPrice : 1;
    const rate = currency === baseCurrency ? 1 : (suppliedRate > 0 ? suppliedRate : fallbackRate);
    page.querySelectorAll('[data-eb-offer]').forEach(input => {
      const count = Number(input.value);
      const original = unitPrice * count;
      const discount = Math.round(Number(input.dataset.baseDiscount) * rate);
      const total = original - discount;
      input.dataset.total = String(total);
      const label = input.closest('.eb-offer');
      label.querySelector('[data-eb-offer-price]').textContent = money(total);
      const compare = label.querySelector('[data-eb-offer-original]');
      if (compare) compare.textContent = money(original);
      const each = money(Math.round(total / Number(input.dataset.shields)));
      label.querySelector('[data-eb-offer-note]').textContent = (count === 1 ? page.dataset.ebUnitTemplate : page.dataset.ebSavingsTemplate).replace('[price]', each).replace('[unit_price]', each).replace('[savings]', money(discount));
    });
    const productForm = page.querySelector('.eb-product-form');
    const error = page.querySelector('[data-eb-error]');
    const add = page.querySelector('[data-eb-add]');
    const sticky = page.querySelector('[data-eb-sticky]');
    const stickyAdd = page.querySelector('[data-eb-sticky-add]');
    const originalButtonText = add?.querySelector('span')?.textContent || 'Add to bag';
    function updateOffer() {
      const offer = page.querySelector('[data-eb-offer]:checked');
      if (!offer) return;
      const amount = money(Number(offer.dataset.total));
      page.querySelectorAll('[data-eb-button-total]').forEach(node => node.textContent = amount);
      const label = page.querySelector('[data-eb-sticky-label]');
      if (label) label.textContent = page.dataset.ebStickyTemplate.replace('[count]', offer.dataset.shields).replace('[price]', amount).replace('[currency]', currency);
    }
    page.querySelectorAll('[data-eb-offer]').forEach(input => input.addEventListener('change', updateOffer));
    updateOffer();
    const testimonialBox = page.querySelector('[data-eb-testimonials]');
    if (testimonialBox) {
      const testimonials = Array.from(testimonialBox.querySelectorAll('[data-eb-testimonial]'));
      let testimonialIndex = 0;
      const moveTestimonial = direction => {
        testimonialIndex = (testimonialIndex + direction + testimonials.length) % testimonials.length;
        testimonials.forEach((item, i) => item.hidden = i !== testimonialIndex);
        testimonialBox.querySelector('[data-eb-testimonial-index]').textContent = (testimonialIndex + 1) + ' / ' + testimonials.length;
      };
      testimonialBox.querySelector('[data-eb-testimonial-prev]')?.addEventListener('click', () => moveTestimonial(-1));
      testimonialBox.querySelector('[data-eb-testimonial-next]')?.addEventListener('click', () => moveTestimonial(1));
    }
    const heroVideo = page.querySelector('[data-eb-hero-video]');
    const heroImage = page.querySelector('[data-eb-hero-image]');
    const galleryButtons = page.querySelectorAll('.eb-thumb');
    function selectGalleryButton(button) {
      galleryButtons.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
    }
    page.querySelector('[data-eb-show-video]')?.addEventListener('click', event => {
      if (!heroVideo || !heroImage) return;
      heroImage.hidden = true;
      heroVideo.hidden = false;
      selectGalleryButton(event.currentTarget);
    });
    page.querySelectorAll('[data-eb-image]').forEach(button => button.addEventListener('click', () => {
      const image = page.querySelector('[data-eb-hero-image]');
      if (!image) return;
      if (heroVideo) {
        heroVideo.pause();
        heroVideo.hidden = true;
      }
      image.hidden = false;
      image.src = button.dataset.ebImage;
      image.alt = button.dataset.ebAlt || image.alt;
      selectGalleryButton(button);
    }));
    const videos = Array.from(page.querySelectorAll('video'));
    videos.forEach(video => video.addEventListener('play', () => videos.forEach(other => { if (other !== video) other.pause(); })));
    if (sticky && add) {
      let stickyFrame = 0;
      const stickyEvents = new AbortController();
      let stickyObserver;
      const updateSticky = () => {
        stickyFrame = 0;
        if (!page.isConnected) {
          stickyEvents.abort();
          stickyObserver?.disconnect();
          return;
        }
        const bounds = add.getBoundingClientRect();
        sticky.hidden = bounds.top >= 0 && bounds.bottom <= window.innerHeight;
      };
      const scheduleSticky = () => {
        if (!stickyFrame) stickyFrame = window.requestAnimationFrame(updateSticky);
      };
      window.addEventListener('scroll', scheduleSticky, {passive:true, signal:stickyEvents.signal});
      window.addEventListener('resize', scheduleSticky, {passive:true, signal:stickyEvents.signal});
      window.addEventListener('hashchange', scheduleSticky, {signal:stickyEvents.signal});
      window.addEventListener('pageshow', scheduleSticky, {signal:stickyEvents.signal});
      if ('IntersectionObserver' in window) {
        stickyObserver = new IntersectionObserver(scheduleSticky, {threshold:0});
        stickyObserver.observe(add);
      }
      scheduleSticky();
    }
    productForm?.addEventListener('submit', async event => {
      event.preventDefault();
      if (!add || add.disabled) return;
      add.disabled = true;
      if (stickyAdd) stickyAdd.disabled = true;
      if (error) error.hidden = true;
      add.setAttribute('aria-busy', 'true');
      add.querySelector('span').textContent = 'Adding to your bag…';
      try {
        const formData = new FormData(productForm);
        formData.set('sections', 'eb-cart-render');
        formData.set('sections_url', window.location.pathname);
        const response = await fetch(page.dataset.addUrl + '.js', {method:'POST',headers:{'Accept':'application/json'},body:formData});
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message || 'We could not add this pack. Please try again.');
        const usePage = window.dispatchEvent(new CustomEvent('eb:cart-added', {cancelable:true, detail:{opener:add, sections:result.sections}}));
        if (usePage) window.location.assign(page.dataset.cartUrl);
      } catch (problem) {
        window.dispatchEvent(new CustomEvent('eb:cart-refresh'));
        if (error) { error.textContent = problem.message; error.hidden = false; }
      } finally {
        add.disabled = false;
        if (stickyAdd) stickyAdd.disabled = false;
        add.removeAttribute('aria-busy');
        add.querySelector('span').textContent = originalButtonText;
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
